import React from "react";
import MenuItem from "./MenuItem";
import type { MenuItem as MenuItemType } from "../types/navigation";

interface NavBarMenuProps {
  menuItems: MenuItemType[];
  activeSubmenu: string | null;
  onMenuClick: (menuItem: MenuItemType) => void;
  onMenuHover: (menuItem: MenuItemType) => void;
  onMenuLeave: () => void;
  menuRefs: React.MutableRefObject<{ [key: string]: HTMLAnchorElement | null }>;
}

const NavBarMenu: React.FC<NavBarMenuProps> = ({
  menuItems,
  activeSubmenu,
  onMenuClick,
  onMenuHover,
  onMenuLeave,
  menuRefs,
}) => (
  <div className="hidden h-full w-1/2 items-center justify-between gap-1 laptop:flex laptop:w-9/12">
    {menuItems.map((menuItem) => (
      <MenuItem
        key={menuItem.key}
        menuItem={menuItem}
        isActive={activeSubmenu === menuItem.key}
        onMenuClick={onMenuClick}
        onMenuHover={onMenuHover}
        onMenuLeave={onMenuLeave}
        menuRef={(el) => {
          menuRefs.current[menuItem.key] = el;
        }}
      />
    ))}
  </div>
);

export default NavBarMenu;
